export const reportKeys = {
  '/cash-flow': 'Cash flow',
  '/cash-flow-statement': 'Cash flow statement',
  '/rent-roll': 'Rent roll',
  '/vacancy-report': 'Vacancy report',
  '/profit-loss': 'Profit & loss',
  '/balance-sheet': 'Balance sheet',
  '/accounts-payable': 'Accounts payable',
  '/owner-statements': 'Owner statements',
  '/tenant-statements': 'Tenant statements',
  '/maintenance-summary': 'Maintenance summary',
  '/magic-tags/leases': 'Lease magic tags',
} as const;

export type ReportKey = keyof typeof reportKeys;

export const generateReportRules = () => {
  return Object.entries(reportKeys).map(([path, label], index) => ({
    match: (pathname: string) => pathname.startsWith(`/reports${path}`),
    generate: (context: any) => [
      { label: context.t('Reports'), link: '/reports' },
      { label: context.t(label), link: `/reports${path}`, linkClass: 'text-black' },
    ],
    backLink: () => '/reports',
    priority: 400 + index,
  }));
};
